import classNames from 'classnames'
import { FieldStatus } from '../types'
import styles from './FieldCounter.module.scss'
import type { FieldCounterProps } from './types'

const FieldCounter = ({
  status = FieldStatus.neutral,
  counter = 0,
  limit,
  className,
}: FieldCounterProps) => {
  if (!limit) return null
  return (
    <span className={classNames(styles['field-counter'], className)} data-status={status}>
      {counter}/{limit}
    </span>
  )
}
export default FieldCounter
